import tv85 from "../../image/85QULED.jpg";
import Aircooler from "../../image/01.jpg";
import Topwashing from "../../image/8.5_WM_02.jpg";
// import washing_machine from "../../image/Semi-Automatic-Washing-Machine-3.png";
import dishwasher from "../../image/dishwaher4.jpg";
import ref from "../../image/528l_R1.jpg";
import Semiwashing from "../../image/02.jpg";
import secondtv from "../../image/AC_2.5trMain.jpg";
// import Aircooler from "../../image/Air Conditioner1.5.jpg";
import refri270 from "../../image/270LRefri.jpg";

export const premiumData = [
  {
    id: 0,
    buyUrl: "https://gshoppi.com/product/6581387da02a3e7d21ac6d07",
    detailsUrl:
      "https://www.gplusindia.com/luxury-appliances/1",
    imageUrl: Topwashing,
  },
  {
    id: 1,
    buyUrl:
      "https://gshoppi.com/product/GPLUS-DISH-WASHER-16-PLACE-SETTINGS-black-(GM-DW-ULTRAX16)/658bbdfb0d16b48350c46ce4",
    detailsUrl: "https://www.gplusindia.com/luxury-appliances/5/1/Gplus-Dishwasher-16-Plate-5-Super-Spray-Showers-Black",
    imageUrl: dishwasher,
  },
  {
    id: 2,
    buyUrl:
      "https://gshoppi.com/product/GPLUS-528-L-FRENCH-DOOR-BOTTOM-FREZZER-Refrigerator-(Silver-GM-528W)/65eae981145ae609d59a8577",
    detailsUrl:
      "https://www.gplusindia.com/luxury-appliances/3",
    imageUrl: ref,
  },
  {
    id: 3,
    buyUrl: "https://gshoppi.com/product/GPLUS-270l-Frost-Free-Refrigerator-with-Water-Dispenser-(GMF2700IWG-Grey)-Matt-Finish/677f878cdfe679a3050ff8ea",
    detailsUrl:
      "https://www.gplusindia.com/luxury-appliances/3",
    imageUrl: refri270,
  },
  {
    id: 5,
    buyUrl:
      "https://gshoppi.com/product/GPLUS-QLED-85-Inches-(214-Cm)-Ultra-HD-4K/6777be55dfe679a3050421aa",
    detailsUrl: "https://www.gplusindia.com/luxury-appliances/2",
    imageUrl: tv85,
  },
  {
    id: 4,
    buyUrl: "https://gshoppi.com/product/67e37e348b2fb7b692bfd8c6",
    detailsUrl: "https://www.gplusindia.com/luxury-appliances/1",
    imageUrl: Semiwashing,
  },

  

  {
    id: 6,
    buyUrl:
      "https://gshoppi.com/product/GPLIUS-Glacier-Smart-Air-Cooler-55-Lit-or-Sensor-Touch-Digital-Control-Panel-and-Remote-Control-or-12H-Timer-Ice-Tray-or-Cooler-for-Home/67e37e348b2fb7b692bfd8c6",
    detailsUrl: "https://www.gplusindia.com/luxury-appliances/7",
    imageUrl: Aircooler,
  },
  {
    id: 7,
    buyUrl:
      "https://gshoppi.com/product/GPLUS-2-Ton-Split-Inverter-AC-Pristine-white/677247bcdfe679a305fbac11",
    detailsUrl: "https://www.gplusindia.com/luxury-appliances/4",
    imageUrl: secondtv,
  },
  // {
  //     id: 5,
  //     url: "https://gshoppi.com/product/GPLUS-QLED-214-Cm-(85-Inches)-Ultra-HD-4K/65d9baf529cf4480e2ffdabc",
  //     imageUrl:refred
  // },
  // {
  //     id: 7,
  //     url: "https://gshoppi.com/product/GPLUS-QLED-214-Cm-(85-Inches)-Ultra-HD-4K/65d9baf529cf4480e2ffdabc",
  //     imageUrl: cooler1
  // },
];
